import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-specialist-medical-appointment-detail',
  templateUrl: './specialist-medical-appointment-detail.component.html',
  styleUrls: ['./specialist-medical-appointment-detail.component.css']
})
export class SpecialistMedicalAppointmentDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
